import { FaInstagram } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { contact } from '../../portfolio';
import './Contact.css';

const Contact = () => {
    if (!contact.email) return null;

    return (
        <section className='section contact center' id='contact'>
            <h2 className='section__title'>Contact</h2>
            <div className='contact-buttons'>
                <a href={ `mailto:${contact.email}` }>
                    <span type='button' className='btn btn--outline'>
                        <MdEmail size={ 15 } />
                    </span>
                </a>
                <a href='https://www.instagram.com/_______chandu________/' target="_blank" rel="noopener noreferrer">
                    <span type='button' className='btn btn--outline'>
                        <FaInstagram size={ 15 } />
                    </span>
                </a>
                <a href='https://x.com/ChndanKuma16973' target="_blank" rel="noopener noreferrer">
                    <span type='button' className='btn btn--outline'>
                        < RiTwitterXFill size={ 15 } />
                    </span>
                </a>
            </div>
        </section>
    );
}

export default Contact;
